<template>
  <div>
    <h1 class="title text-uppercase font-weight-bold">Produtos para aprovação</h1>

    <hr class="linha-amarela" />

    <div class="mt-4">
      <table class="table table-striped table-bordered">
        <thead class="letter-orange">
            <th>Produto</th>
            <th>Cod. barras</th>
            <th>Marca</th>
            <th>Unidade</th>
            <th>Peso (Kg)</th>
            <th>Altura (Cm)</th>
            <th>Largura (Cm)</th>
            <th>Comprimento (Cm)</th>
            <th class="text-center">Status</th>
            <th class="text-center">Visualizar</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.produto }}</td>
            <td>{{ item.codbar }}</td>
            <td>{{ item.marca }}</td>
            <td>{{ item.unidade }}</td>
            <td>{{ item.peso }}</td>
            <td>{{ item.altura }}</td>
            <td>{{ item.largura }}</td>
            <td>{{ item.comprimento }}</td>
            <td class="text-center">
              <span style="color:blue" v-if="item.cad_status == 1">Aguardando aprovação</span>
              <span style="color:green" v-if="item.cad_status == 2">Aprovado</span>
              <span style="color:red" v-if="item.cad_status == 3">Reprovado</span>
            </td>
            <td class="text-center">
              <span class="btn btn-primary mr-2" @click="visualizar(item)">
                <i class="fas fa-eye"></i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-modal
      title="Detalhes do produto"
      size="xl"
      id="modalProduto"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
      <b-row>
        <b-col cols="9" class="mb-2">
            <label>Nome do produto</label>
            <input type="text" class="form-control" :value="produto.produto" readonly>
        </b-col>

        <b-col cols="3" class="mb-2">
            <label>Código de barra</label>
            <input type="text" class="form-control" :value="produto.codbar" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Marca</label>
            <input type="text" class="form-control" :value="produto.marca" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Unidade de medida</label>
            <input type="text" class="form-control" :value="produto.unidade" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Peso (Kg)</label>
            <input type="text" class="form-control" :value="produto.peso" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Altura (Cm)</label>
            <input type="text" class="form-control" :value="produto.altura" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Largura (Cm)</label>
            <input type="text" class="form-control" :value="produto.largura" readonly>
        </b-col>

        <b-col cols="2" class="mb-2">
            <label>Comprimento (Cm)</label>
            <input type="text" class="form-control" :value="produto.comprimento" readonly>
        </b-col>

        <b-col cols="12" class="mb-2">
            <label>Descrição do produto</label>
            <textarea class="form-control" rows="3" placeholder="Descrição do produto" :value="produto.descricao" readonly></textarea>
        </b-col>

        <b-col cols="12" class="mb-2 mt-2">
            <label>Categoria: </label>
            <span class="ml-2"><b>{{produto.departamento}}</b></span>
        </b-col>

        <b-col cols="6" class="mt-2">

            <label>Ficha(s) tec</label>
            <table class="table table-striped table-bordered mt-2">
                <thead>
                    <tr>
                    <th scope="col">Nº</th>
                    <th scope="col">Tipo</th>
                    <th scope="col">Descrição</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in produto.produto_fichas" :key="i" v-show="produto.produto_fichas && produto.produto_fichas.length > 0">
                        <td>{{i + 1}}</td>
                        <td>{{item.tipo}}</td>
                        <td>{{item.descricao}}</td>
                    </tr>
                    <tr v-if="produto.produto_fichas && produto.produto_fichas.length == 0">
                        <td colspan="3">
                            <span>Sem ficha tec. cadastrada!</span>
                        </td>
                    </tr>
                </tbody>
                </table>
        </b-col>

        <b-col cols="6" class="mt-2">
            <label>Foto(s) do produto</label>
            <b-row>
              <b-col cols="2" class="mt-1 mr-2 text-center" v-for="(item, i) in produto.produto_fotos" :key="i">
                <img :src="formatUrl(item.foto_png)" alt="Produto cadastrado" width="70">
              </b-col>
            </b-row>
        </b-col>
      </b-row>
  </b-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
export default {
  mixins: [makeToast],
  
  name: 'ProdutosAprovacao',
  data() {
    return {
      data: [],
      produto: []
    };
  },


  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  created() {
    this.buscarProdutos();
  },

  methods: {
    visualizar(item) {
      this.produto = item;
      this.$bvModal.show('modalProduto');
    },
    buscarProdutos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/bucarNovoProdutoLojista', this.dadosUsuario.id)
        .then((response) => {
          this.data = response.data;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    formatUrl(foto) {
      return process.env.VUE_APP_FOTOS_URL+foto;
    },
  },
}
</script>
